<template>
  <div class="container-md">
    <h1 class="page-header">System settings</h1>

    <div class="row mb-5">
      <div class="col-4">
        <input
          class="form-control"
          type="text"
          v-model="newKey"
          @keydown.enter="addItem"
          placeholder="Add a new setting key"
        />
      </div>
      <button type="button" class="btn btn-primary" @click="addItem">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Setting</th>
            <th>Value</th>
            <th>Note</th>
            <th style="width: 2em;">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in items" :key="i.id">
            <td>
              {{ i.key }}
            </td>
            <td>
              <textarea-autosize
                class="form-control d-block"
                :min-height="20"
                :max-height="200"
                @input="handleInput($event, i)"
                v-model="i.value"
              />
            </td>
            <td>
              <textarea-autosize
                class="form-control"
                :min-height="20"
                :max-height="200"
                @input="handleInput($event, i)"
                v-model="i.note"
              />
            </td>
            <td class="text-center">
              <span
                v-if="i.saving"
                class="spinner-border spinner-border-sm input-loading text-muted"
              ></span>
              <button type="button" v-else class="btn btn-sm btn-outline-danger" @click="handleDelete(i)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { authFetch } from "../lib/auth.js";
import Vue from 'vue'
import TextareaAutosize from 'vue-textarea-autosize'
 
Vue.use(TextareaAutosize)

export default {
  data() {
    return {
      newKey: "",
      items: [],
      loading: true,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    handleInput(e, item) {
      if (this.loading) {
        return
      }
      if (item.timeout) {
        clearTimeout(item.timeout);
      }
      item.timeout = setTimeout(() => {
        item.saving = true;
        authFetch(`/db/setting/${item.id}`, {
          method: "put",
          body: JSON.stringify(item),
        }).then(() => {
          setTimeout(() => (item.saving = false), 400);
        });
      }, 1000);
    },
    handleDelete(item) {
      if (confirm("Delete item?") === true) {
        authFetch(`/db/setting/${item.id}`, {
          method: "delete",
        }).then(() => this.load());
      }
    },
    addItem() {
      if (this.newKey) {
        authFetch(`/db/setting`, {
          method: "post",
          body: JSON.stringify({key: this.newKey, value: "", note: ""}),
        }).then(() => this.load());
        this.newKey = ""
      }
    },
    load() {
      let uri = "/db/setting?&sort=key";
      authFetch(uri)
        .then((resp) => resp.json())
        .then((data) => {
          this.items = data.map((i) => Object.assign(i, { saving: false })) // Makes 'saving' reactive
          setTimeout(() => this.loading = false, 100)
        });
    },
  },
};
</script>

<style scoped>
textarea {
  min-width: 16em;
}
</style>